export type CountryDialCode = {
	code: string;
	isoCode: string;
	label: string;
	searchTerms: string[];
};

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
	{
		code: "243",
		isoCode: "CD",
		label: "RDC",
		searchTerms: ["rdc", "congo", "congo kinshasa", "+243", "cd"],
	},
];